import useApiMutation from '@hooks/useApiMutation';

interface RdgToggleRequest {
  enabled: boolean;
}

interface RdgToggleResponse {
  success: boolean;
  enabled: boolean;
  message: string;
}

export const useRdgToggleMutation = () =>
  useApiMutation<RdgToggleRequest, RdgToggleResponse>({
    apiPath: '/rdg/toggle',
    method: 'POST',
    useV2API: true,
  });
